import { useMemo } from 'react';

export const useDivisionVehicleHistoryData = (trackPoints, dataVehiclesResource) => {
  const vehicleTracksMap = useMemo(() => {
    if (!trackPoints?.length) {
      return {};
    }

    const map = {};

    // Группируем точки по vehicleId
    trackPoints.forEach((point) => {
      const vId = point.vehicleId;
      if (!map[vId]) {
        map[vId] = [];
      }
      map[vId].push(point);
    });

    // Сортируем точки каждого ТС по времени
    Object.keys(map).forEach((vId) => {
      map[vId].sort((a, b) => new Date(a.date) - new Date(b.date));
    });

    return map;
  }, [trackPoints]);

  /**
   * Информация о каждом ТС по его ID: {vehicleId: vehicleData}
   * Используется для получения details о ТС (номер, модель, цвет и т.д.)
   */
  const vehiclesInfo = useMemo(() => {
    if (!dataVehiclesResource?.data?.length) return {};

    const info = {};
    dataVehiclesResource.data.forEach((vehicle) => {
      info[vehicle.vehicleId] = vehicle;
    });
    return info;
  }, [dataVehiclesResource?.data]);

  /**
   * Все точки объединенные в один массив и отсортированные по времени
   * Используется для общей статистики и воспроизведения
   */
  const allCoords = useMemo(() => {
    if (Object.keys(vehicleTracksMap).length === 0) return [];

    const combined = [];
    Object.values(vehicleTracksMap).forEach((tracks) => {
      combined.push(...tracks);
    });

    // Сортируем общий массив по времени
    return combined.sort((a, b) => new Date(a.date) - new Date(b.date));
  }, [vehicleTracksMap]);

  return {
    vehicleTracksMap, // {vehicleId: [points]} - для отображения маршрутов
    vehiclesInfo, // {vehicleId: vehicleData} - информация о ТС
    allCoords, // все точки вместе
    isEmpty: allCoords.length === 0,
  };
};

export default useDivisionVehicleHistoryData;
